import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, useDisclosure } from '@chakra-ui/react';
import { BlockErrors, ClearBtnBase, MarkdownBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { ValuesType } from '@/types';
import { getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
import { SignatureModal } from './SignatureModal';
import { SignaturePreview } from './SignaturePreview';
export const Signature = ({ block, defaultValue = null, errors = [], onChange, options }) => {
    const modal = useDisclosure();
    const [resolver] = useResolveValue();
    const config = {
        cancelLabel: resolver.resolveString(block.cancel_label),
        clearLabel: resolver.resolveString(block.clear_label),
        confirmLabel: resolver.resolveString(block.confirm_label),
        nameLabel: resolver.resolveString(block.answer.label),
        passwordLabel: resolver.resolveString(block.password_label),
        usernameLabel: resolver.resolveString(block.username_label),
        reasonLabel: resolver.resolveString(block.reason_selector.label),
        noSelectionText: resolver.resolveString(block.reason_selector.no_selection_text),
        reasons: block.reason_selector.answers.map((item) => (Object.assign(Object.assign({}, item), { label: resolver.resolveString(item.label) }))),
        title: resolver.resolveString(block.modal_title)
    };
    const hasSignature = Boolean(defaultValue);
    const updateAnswer = (value) => {
        const newAnswer = getInputBlockAnswer(ValuesType.SIGNATURE, Object.assign(Object.assign({}, block.answer), { label: config.nameLabel, value }), block.key);
        onChange(newAnswer);
    };
    const handleConfirm = (signature) => {
        updateAnswer(signature);
        modal.onClose();
    };
    const handleClear = (e) => {
        e.stopPropagation();
        updateAnswer(null);
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsxs(BlockLayout, Object.assign({ layout: block.layout }, { children: [_jsxs(Flex, Object.assign({ _hover: { borderColor: 'darkBrandBlue.40' }, _focusWithin: { boxShadow: 'var(--chakra-shadows-outline)' }, align: 'center', border: '2px solid', borderColor: errors.length > 0 ? 'red.100' : 'darkBrandBlue.10', borderRadius: '8', "data-test": block.id, justify: 'space-between', overflow: 'hidden', transition: 'border-color .2s ease' }, { children: [_jsx(Button, Object.assign({ _focusVisible: { outline: 'none' }, bg: 'transparent', color: 'inherit', fontWeight: 'normal', flex: '1', h: 'auto', justifyContent: 'flex-start', onClick: modal.onOpen, p: '4' }, { children: _jsx(SignaturePreview, { signature: defaultValue, label: config.nameLabel }) })), hasSignature && (_jsx(ClearBtnBase, Object.assign({ mx: '4', onClick: handleClear, px: '3' }, { children: _jsx(MarkdownBase, { markdown: config.clearLabel }) })))] })), _jsx(SignatureModal, { config: config, initialSignature: defaultValue, isOpen: modal.isOpen, onCancel: modal.onClose, onConfirm: handleConfirm, submittedBy: options === null || options === void 0 ? void 0 : options.submitted_by })] })) })));
};
